<template>
  <div>
    <main class="static-page">
      <div class="static-page__content">

        <section
          v-html="pageData.description1"
          class="static-page__descr"
        />
        <section
          v-html="pageData.description2"
          class="static-page__descr"
        />
      </div>
    </main>
  </div>
</template>

<script>
  export default {
    name: 'PublicOffer',
    computed: {
      pageData() {
        return this.$store.state.page.pageData
      }
    }
  }
</script>
